import type { LabelProps as AriaLabelProps } from 'react-aria-components';
import { Label as AriaLabel } from 'react-aria-components';
import styles from './FieldLabel.module.css';

export interface FieldLabelProps extends AriaLabelProps {
  /*
   * Whether the FieldLabel is required
   */
  required?: boolean;
}

export const FieldLabel = ({
  children,

  ...props
}: FieldLabelProps) => {
  return (
    <AriaLabel className={styles.fieldLabel} {...props}>
      {children}
    </AriaLabel>
  );
};

export default FieldLabel;
